import request from 'services/axios';

export const getPostLists = async (paramsObject: getPostLists) => {
  let mainUrl = '/api/v2/market/post-list?';
  for (const property in paramsObject) {
    if (paramsObject[property]) {
      mainUrl = mainUrl + `&${property}=${paramsObject[property]}`;
    }
  }
  const {data}: {data: IPostListData} = await request.get(mainUrl);
  return data;
};
export const getHotPostLists = async (paramsObject: getPostLists) => {
  let mainUrl = '/api/v2/market/trended-auction-list?';
  for (const property in paramsObject) {
    if (paramsObject[property]) {
      mainUrl = mainUrl + `&${property}=${paramsObject[property]}`;
    }
  }
  const {data}: {data: IPostListData} = await request.get(mainUrl);
  return data;
};
